import { Chevron } from '../Chevron';
import { normalizeLabel } from '../../utils/normalizeLabel';

export type OptionHeaderProps = {
	left: string;
	right: string;
	onClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>): void;
	active?: boolean;
	secondary?: boolean;
	/**
	 * Used to set a data attribute "data-name" on the root element of this
	 * component.
	 *
	 * Useful for e2e testing.
	 */
	name?: string;
};

export const OptionHeader: React.FC<OptionHeaderProps> = ({
	left,
	right,
	onClick,
	active = false,
	name
}) => (
	<div
		onClick={onClick}
		data-name={name ? normalizeLabel(name) : undefined}
		className="d-flex align-items-center cursor-pointer py-3 option-header"
	>
		<p
			className={`mb-0 font-weight-bold mr-2 text-nowrap`}
			style={{ color: '#343a40' }}
		>
			{left}
		</p>

		<p className="mb-0 ml-auto text-truncate">{right} </p>

		<div className="ml-2">
			<Chevron isActive={active} color="primary" />
		</div>
	</div>
);
